import { DateTime } from 'luxon';

/**
 * Formats the elapsed time since `dateString` as a compact, single-unit badge — the largest whole
 * unit only: minutes, hours, days, or weeks (e.g. "12m", "6h", "3d", "2w"). Unlike `relativeDate` /
 * `formatLastUpdated` (which emit localized prose like "3 days ago"), this is a terse, unit-suffixed
 * label suited to chips/badges. Returns an empty string when the date is missing or invalid; future
 * dates clamp to "0m".
 */
export const formatCompactAge = (dateString: string | null | undefined): string => {
    if (!dateString) {
        return '';
    }

    const dateTime = DateTime.fromISO(dateString);
    if (!dateTime.isValid) {
        return '';
    }

    const minutes = Math.max(0, Math.floor(DateTime.now().diff(dateTime, 'minutes').minutes));
    if (minutes < 60) {
        return `${minutes}m`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
        return `${hours}h`;
    }

    const days = Math.floor(hours / 24);
    if (days < 7) {
        return `${days}d`;
    }

    return `${Math.floor(days / 7)}w`;
};
